export enum ValueStream {
  VS1 = 'VS1',
  VS2 = 'VS2',
}

export enum OrderType {
    Order = 'order',
    Cleaning = 'limpieza',
    Quality = 'calidad',
    Preparacion = 'preparacion',
}

export enum FieldType {
    Text = 'text',
    Number = 'number',
    Date = 'date',
    Object = 'object',
}